import script from "./Quiz.vue?vue&type=script&setup=true&lang=ts"
export * from "./Quiz.vue?vue&type=script&setup=true&lang=ts"

import "./Quiz.vue?vue&type=style&index=0&id=2848a956&scoped=true&lang=css"
import "./Quiz.vue?vue&type=style&index=1&id=2848a956&lang=scss&scoped=true"

import exportComponent from "/Users/alessiomealli/WebstormProjects/switaly/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2848a956"]])

export default __exports__